import { action } from '@ember/object';
import { service } from '@ember/service';

import type { Billing, PopupData, RequestError, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class BillingPopupAddonCancelComponent extends PopupInnerModalComponent<PopupData.Billing.AddonCancel> {
	@service('billing') declare billingService: Service.Billing;
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('request') declare requestService: Service.Request;

	get model(): Billing.Addon {
		return this.popupData.model;
	}

	@action
	disable() {
		if (this.submitInProgress) {
			return;
		}

		this.submitInProgress = true;
		this.billingService
			.removeAddon(this.model.id)
			.then(
				() => {
					this.infolayerService.ok('Addon removed!');
					this.close();
				},
				(errorData: RequestError) => {
					this.requestService.handleGenericThrownError(errorData);
				},
			)
			.finally(() => {
				this.submitInProgress = false;
			});
	}
	<template>
		<div class="content">

			<img
				src="https://cdn1.databox.com/images/logo/databox-square.png"
				width="50"
				height="50"
				alt
			/>

			<h2>Are you sure you want to disable {{this.model.name}}?</h2>

			<p>
				You are about to cancel your
				{{this.model.name}}
				add-on. We will effectively disable it on
				<strong>{{this.billingService.formattedActiveUntil}}</strong>.
			</p>

			<div class="controls2 controls2--center">
				<SubmitButtonComponent
					@text="Cancel add-on"
					@theme="red"
					@size="big"
					@onTrigger={{this.disable}}
					@submitInProgress={{this.submitInProgress}}
				/>
				<SubmitButtonComponent
					@text="Cancel"
					@theme="grey-empty"
					@onTrigger={{this.close}}
				/>
			</div>

		</div>
	</template>
}
